export default __webpack_public_path__ + "static/media/Menu.52223e71.jpg";